<template>
  <article class="mmp_home">
    <div id="content" class="content">
      <template v-if="portletList.length > 0">
        <div v-for="item in portletList" :key="item.potltNo">
          <template v-if="item.potltCd === 'NRW_MN_BAN' && hasPortletData(item)">
            <!-- 모바일웹 메인배너 -->
            <CompMmpVisualSlide2
              :potlt-info="item"
              :cu-type="item.potltData[0].potltMrkTyp === 'CNTR_GAL' ? 'visual' : 'gallery'"
            />
          </template>
          <template v-if="item.potltCd === 'NRW_PROMO' && hasPortletData(item)">
            <!-- 모바일웹 프로모션 -->
            <section class="section_home quick_menu no_padding" data-effect-slide="scroll">
              <Promotion
                v-show="!isDesktop"
                :potlt-info="item"
                :classes="['wrap_icon_menu', 'mo']" />
            </section>
          </template>
          <template v-if="item.potltCd === 'NRW_BND' && hasPortletData(item)">
            <!-- 모바일웹 띠배너 -->
            <!--
               배너 (1줄 2개 노출)
               - banner-id: 캠페인 ID
               - slides-per-view: 한 화면에 노출할 배너 갯수 (1~2)
                 (기본값: 2)
            -->
            <!--
              배너 (1줄 1개 노출)
              - motionEffect 처리할 필요 없는 엘리먼트에 'no_effect' 클래스 추가
            -->
            <div :class="{'no_effect' : !isDesktop || item.potltData[0].maxSetupNum === 1}">
              <BandBanner
                :banner-id="item.potltStdilSeq"
                :class="{'no_padding': item.potltData[0].maxSetupNum !== 2}"
                :potlt-info="item"
                :slides-per-view="item.potltData[0].maxSetupNum" />
            </div>
          </template>
          <template v-if="item.potltCd === 'NRW_USR_DEF' && item.corsList.length > 0">
            <!--
                과정 큐레이선 리스트 컴포넌트 (pc visual)
                - PC, TABLET, MO UI 기준 props 값 설정
                - 개별설정값은 전역설정값을 무시함

                - swiper: 스와이퍼 적용 여부 ('Y', 'N') / 기본값 'Y'

                - cu-type: UI 스타일 (list, gallery, visual) / 기본값 'gallery'
                  - 'list' 형은 swiper 적용 안됨 ('gallery', 'visual' 형태만 swiper 적용)
                  - cu-type-mobile: 개별 설정
                  - cu-type-tablet: 개별 설정
                  - cu-type-pc: 개별 설정

                (mobile gallery) 인 경우에만 적용
                - gallery-size: 갤러리형 카드 사이즈 ('large', 'medium', 'small') / 기본값 'medium'

                - show-label: (전역) 제목 상단 라벨 영역 표시 여부 ('Y', 'N') / 기본값 'Y'
                  - show-label-mobile: 개별 설정
                  - show-label-tablet: 개별 설정
                  - show-label-pc: 개별 설정

                - show-review: (전역) 제목 하단 리뷰 영역 표시 여부 ('Y', 'N') / 기본값 'Y'
                  - show-review-mobile: 개별 설정
                  - show-review-tablet: 개별 설정
                  - show-review-pc: 개별 설정

                - show-tag: (전역) 제목 하단 태그 영역 표시 여부 ('Y', 'N') / 기본값 'Y'
                  - show-tag-mobile: 개별 설정
                  - show-tag-tablet: 개별 설정
                  - show-tag-pc: 개별 설정

                - show-more-btn: (전역) 더보기 버튼 표시 여부 ('Y', 'N') / 기본값 'Y'
                  - show-more-btn-mobile: 개별 설정
                  - show-more-btn-tablet: 개별 설정
                  - show-more-btn-pc: 개별 설정

                (gallery 인 경우에만 적용)
                - slides-per-view-mobile: (mo) 한 화면에 보여줄 슬라이드 갯수 (1 ~ 4) / 기본값 1.3
                - slides-per-view-tablet: (tablet) 한 화면에 보여줄 슬라이드 갯수 (1 ~ 4) / 기본값 1.4
                - slides-per-view-pc: (pc) 한 화면에 보여줄 슬라이드 갯수 (1 ~ 4) / 기본값 3

                (swiper 유형이 아닌 경우에만 적용)
                - columns-mobile: (mo) 한 줄에 보여줄 아이템 갯수 (1 ~ 2) / 기본값 1
                - columns-tablet: (tablet) 한 줄에 보여줄 아이템 갯수 (1 ~ 4) / 기본값 2
                - columns-pc: (pc) 한 줄에 보여줄 아이템 갯수 (1 ~ 4) / 기본값 2

                (tab 콘텐츠인 경우)
                - tab-list: tab list 배열값
                - tab-bg-color: tab을 감싸는 외부 wrapper의 색상 / 기본값 '#fff'
          -->

            <!-- 과정 큐레이선 (가운데갤러리형) -->
            <UserCuration
              v-if="item.potltData[0].potltMrkTyp === 'CNTR_GAL'"
              :cu-id="item.potltData[0].potltNo"
              :cu-title="getPortletData(item) ? `${item.potltNm}` : ''"
              :cu-type-pc="'visual'"
              :gallery-size="'large'"
              :more-btn-txt="'강의 더보기'"
              :potlt-info="item"
              :show-cu-title="showCuTitle(item)"
              :show-date="showDate(item)"
              :show-html-title="showTitle(item)"
              :show-label="showLabel(item)"
              :show-review="showReview(item)"
              :show-tag="item.potltData[0].tagExpsrYn"
            />

            <!--
                  과정 큐레이선 (갤러리형, 리스트형)
                  Tab형태 큐레이션은 갤러리형, 리스트형 만 가능
            -->
            <UserCuration
              v-else
              :crtn-typ="item.potltData[0].crtnTyp"
              :cu-id="item.potltData[0].potltNo"
              :cu-title="getPortletData(item) ? item.potltNm : ''"
              :cu-type="cuType(item)"
              :gallery-size="gallerySize(item)"
              :more-btn-txt="moreBtnTxt(item)"
              :potlt-info="item"
              :slides-per-view-pc="slidesPerViewPc(item)"
              :show-cu-title="showCuTitle(item)"
              :show-date="showDate(item)"
              :show-html-title="showTitle(item)"
              :show-label="showLabel(item)"
              :show-review="showReview(item)"
              :show-tag="item.potltData[0].tagExpsrYn"
              :space-between="spaceBetween(item)"
              :swiper="swiper(item)"
            />
          </template>

          <template v-if="item.potltCd === 'NRW_RV_CRS' && hasPortletData(item)">
            <!-- 모바일웹 수강후기 -->
            <ReviewCors :potlt-info="item" />
          </template>
          <template v-if="item.potltCd === 'NRW_INFO_COMP'">
            <!-- 모바일웹 기업정보 -->
            <CompanyInfo :potlt-info="item" />
          </template>
        </div>
      </template>
    </div>
  </article>
</template>

<script>
import commonMixin from '@/mixin/commonMixin'
import MainBanner from '~pages/nrw/portlet/MainBanner.vue'
import Promotion from '~pages/nrw/portlet/Promotion.vue'
import BandBanner from '~pages/nrw/portlet/BandBanner.vue'
import UserCuration from '~pages/nrw/portlet/UserCuration.vue'
import ReviewCors from '~pages/nrw/portlet/ReviewCors.vue'
import PopupBanner from '~pages/nrw/portlet/PopupBanner.vue'
import CompanyInfo from '~pages/nrw/portlet/CompanyInfo.vue'
import TextMenu from '~pages/nrw/portlet/TextMenu.vue'
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import CompMmpVisualSlide2 from '~pages/nrw/portlet/CompMmpVisualSlide2.vue'
import CompEventMenuMo from '~pages/nrw/portlet/CompEventMenuMo.vue'
import CompCourseCurationSwiper from '~pages/nrw/portlet/CompCourseCurationSwiper.vue'
import UserCurationTabList from '~pages/nrw/portlet/UserCurationTabList.vue'
import CompMainBanner from '~pages/nrw/portlet/CompMainBanner.vue'
import CompReviewRadialSlide from '~pages/nrw/portlet/CompReviewRadialSlide.vue'
import CompFloatNav from '~pages/nrw/portlet/CompFloatNav.vue'
import MotionEffects from '/src/assets/js/MotionEffects'
import PromotionModal from '~pages/nrw/modal/PromotionModal.vue'

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
    CompMmpVisualSlide2,
    CompEventMenuMo,
    CompCourseCurationSwiper,
    UserCurationTabList,
    CompMainBanner,
    CompReviewRadialSlide,
    CompFloatNav,
    MainBanner,
    Promotion,
    BandBanner,
    UserCuration,
    ReviewCors,
    PopupBanner,
    CompanyInfo,
    TextMenu,
    PromotionModal
  },
  mixins: [commonMixin, MotionEffects],
  metaInfo () {
    console.log('metaInfo chaged!!!')
    return {
      title: this.getSiteNm() + ' :: ' + '메인'
    }
  },
  props: {
    portletList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      hasMmpHeader: true, // 헤더 존재 여부
      hasMmpFooter: true, // 푸터 존재 여부
      hasMmpBottomNav: true, // bottom navigation 존재 여부
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      isHidden: false
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    portletData () {
      return this.portletList.find(item => item.potltCd === 'NRW_POPUP')
    },
    promoPopupData () {
      if (this.popupData > 0) {
        return this.portletData.potltData.map(item => ({
          title: item.bannNm,
          img: {
            pc: `/mrm/v1/ignore/attach/image/${item.imgAttchFileId}/${item.imgFileId}`,
            mo: `/mrm/v1/ignore/attach/image/${item.mobImgAttchFileId}/${item.mobImgFileId}`
          },
          bannUrl: item.bannUrl,
          genLinkScCd: item.genLinkScCd
        }))
      }
    },
    popupData () {
      return this.portletData && this.portletData.potltData ? this.portletData.potltData.length : 0
    }
  },
  watch: {
    popupData (newLength) {
      if (newLength > 0) {
        this.checkIfHiddenForToday()
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.popupData > 0) {
        // 쿠키 체크
        this.checkIfHiddenForToday()
      }
    })
  },
  methods: {
    openPromotionModal () {
      setTimeout(() => {
        this.$popup.openModal(this.$el, PromotionModal, {
          fullModal: false,
          title: (this.portletData && this.portletData.potltNm) ? this.portletData.potltNm : 'PopUP',
          header: false,
          footer: false,
          classes: ['promotion_modal'],
          promoPopupData: this.promoPopupData
        })
      }, 1000)
    },
    // 쿠키 체크
    checkIfHiddenForToday () {
      const hidePopupData = JSON.parse(localStorage.getItem('hidePopupData'))
      const now = new Date().getTime()

      if (hidePopupData && hidePopupData.hidePopupForToday && hidePopupData.hideUntil > now) {
        this.isHidden = true
      } else {
        if (!this.isHidden) {
          this.openPromotionModal()
        }
      }
    },
    hasPortletData (item) {
      return item.potltData && item.potltData.length > 0
    },
    getPortletData (item) {
      return item.potltData && item.potltData.length > 0 ? item.potltData[0] : null
    },
    cuType (item) {
      const potltData = this.getPortletData(item)
      if (this.hasPortletData) {
        const { potltMrkTyp, crtnTyp } = potltData
        if (potltMrkTyp === 'LST') return 'list'
        if (potltMrkTyp === 'GAL' || crtnTyp === 'TAB') return 'gallery'
      }
      return 'visual'
    },
    moreBtnTxt (item) {
      const potltData = this.getPortletData(item)
      if (potltData) {
        const { crtnTyp } = potltData
        if (crtnTyp === 'TAB') return '강의 더보기'
      }
      return '더보기'
    },
    gallerySize (item) {
      const potltData = this.getPortletData(item)
      if (potltData) {
        const { potltMrkTyp, maxSetupNum } = potltData
        if (potltMrkTyp === 'GAL') {
          // 모바일 일 때는 medium으로 고정
          return maxSetupNum === 3 ? 'medium' : (this.isDesktop ? 'small' : 'medium')
        }
      }
      return 'large'
    },
    slidesPerViewPc (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.potltMrkTyp === 'GAL' ? potltData.maxSetupNum : 0
    },
    showCuTitle (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.potltNmExpsrYn === 'Y'
    },
    showDate (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.lrnPrdExpsrYn === 'Y'
    },
    showLabel (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.tagExpsrYn
    },
    showReview (item) {
      const potltData = this.getPortletData(item)
      return potltData ? potltData.rtngPscrtExpsrYn : false
    },
    showTitle (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.corsNmExpsrYn === 'Y'
    },
    spaceBetween (item) {
      const potltData = this.getPortletData(item)
      return potltData ? potltData.btomGapNum : 0
    },
    swiper (item) {
      const potltData = this.getPortletData(item)
      return potltData && potltData.crtnTyp === 'TAB' ? 'N' : 'Y'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/main/Home.vue